import { FC, useCallback, useMemo } from 'react';
import { SyncAppQueries } from '@frontend/api-sync-app';
import { GlobalBannerDynamic } from '@frontend/global-info-banner';
import { useAppScopeStore } from '@frontend/scope';
import { getActionTitleAndLink, getMessageAndTitle } from '../utils';

export const CornerstonOnPremIntegrationDeprecationBanner: FC = () => {
  const { selectedOrgId } = useAppScopeStore();

  const res = SyncAppQueries.useLocationDataSources({
    locationId: selectedOrgId,
  });

  const { actionTitle, link } = getActionTitleAndLink();
  const { message, title } = getMessageAndTitle();

  const handleClick = useCallback(() => {
    window.open(link, '_blank');
  }, [link]);

  const actions = useMemo(
    () => ({
      label: actionTitle,
      onClick: handleClick,
    }),
    [actionTitle, handleClick]
  );

  if (!selectedOrgId || !res.data || res.isLoading || res.isError) {
    return null;
  }

  const hasCloudSources =
    res &&
    res.data &&
    res.data.dataSources &&
    res.data.dataSources.filter((source) => source && source.integration?.name === 'CORNERSTONE_CLOUD');

  const hasOnPremSources =
    res &&
    res.data &&
    res.data.dataSources &&
    res.data.dataSources.filter((source) => source && source.integration?.name === 'CORNERSTONE');

  const shouldShow = hasCloudSources.length < hasOnPremSources.length;

  if (shouldShow) {
    return (
      <GlobalBannerDynamic
        type='error'
        id='cornerstone-onprem-deprecation-alert-banner'
        message={message}
        isDismissible={false}
        title={title}
        trackingId='cornerstone-onprem-deprecation-button'
        action={actions}
      />
    );
  } else {
    return null;
  }
};
